import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import ErrorBoundary from '@sbt-web/error-boundary';
import type { PresenceStatus } from '@sbt-web/network/types';
import { Button } from '@sbt-web/ui';
import { UserRating } from '@/client/components/Detail/UserRating';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import { Presence } from './components/Presence';
import { PrivateUserBadgeSize, UserBadge } from './components/UserBadge';
import { UserName } from './components/UserName';
import styles from './PrivateUserProfileBadge.module.scss';
export interface PrivateUserProfileBadgeProps {
  name: string;
  userId: string;
  pulseEventName: string;
  publishFromText?: string;
  size?: PrivateUserBadgeSize;
  classes?: string[];
  profileUrl?: string;
  picture?: string;
  score?: number;
  presenceStatus?: PresenceStatus;
  presenceText?: string;
  reviewCount?: number;
  showContactButton?: boolean;
}
const getProfileUrl = (userId: string): string => `/utente/${userId}`;
const PrivateUserProfileBadgeComponent = t0 => {
  const $ = _c(49);
  const {
    name,
    publishFromText,
    size,
    classes,
    userId,
    profileUrl,
    pulseEventName,
    picture,
    score,
    presenceStatus,
    presenceText,
    reviewCount,
    showContactButton: t1
  } = t0;
  const showContactButton = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== pulseEventName || $[1] !== userId) {
    t2 = () => {
      getOrCreatePulse()?.queueEvent({
        type: "Engagement",
        object: {
          "@type": "UIElement",
          "@id": `sdrn:subito:classified:${userId}:element:${pulseEventName}`
        }
      });
    };
    $[0] = pulseEventName;
    $[1] = userId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const trackLinkClick = t2;
  const t3 = size === PrivateUserBadgeSize.Small;
  let t4;
  if ($[3] !== classes || $[4] !== t3) {
    t4 = classNames(styles.container, {
      [styles.small]: t3
    }, classes);
    $[3] = classes;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== profileUrl || $[7] !== userId) {
    t5 = profileUrl ?? getProfileUrl(userId);
    $[6] = profileUrl;
    $[7] = userId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = size === PrivateUserBadgeSize.Small ? presenceStatus : undefined;
  let t7;
  if ($[9] !== name || $[10] !== picture || $[11] !== size || $[12] !== t5 || $[13] !== t6 || $[14] !== trackLinkClick) {
    t7 = <UserBadge name={name} url={t5} size={size} handleClick={trackLinkClick} picture={picture} presenceStatus={t6} />;
    $[9] = name;
    $[10] = picture;
    $[11] = size;
    $[12] = t5;
    $[13] = t6;
    $[14] = trackLinkClick;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== profileUrl || $[17] !== userId) {
    t8 = profileUrl ?? getProfileUrl(userId);
    $[16] = profileUrl;
    $[17] = userId;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== name || $[20] !== t8 || $[21] !== trackLinkClick) {
    t9 = <UserName name={name} url={t8} handleClick={trackLinkClick} />;
    $[19] = name;
    $[20] = t8;
    $[21] = trackLinkClick;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = getOrCreatePulse();
    t11 = [styles.rating];
    $[23] = t10;
    $[24] = t11;
  } else {
    t10 = $[23];
    t11 = $[24];
  }
  let t12;
  if ($[25] !== reviewCount || $[26] !== score || $[27] !== userId) {
    t12 = <UserRating userId={userId} pulseInstance={t10} classes={t11} score={score} reviewCount={reviewCount} />;
    $[25] = reviewCount;
    $[26] = score;
    $[27] = userId;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== publishFromText) {
    t13 = publishFromText && <p className={classNames("body-text", "small", styles.message)}>{publishFromText}</p>;
    $[29] = publishFromText;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== presenceStatus || $[32] !== presenceText || $[33] !== size) {
    t14 = presenceStatus && presenceText && size !== PrivateUserBadgeSize.Small && <Presence presenceText={presenceText} presenceStatus={presenceStatus} />;
    $[31] = presenceStatus;
    $[32] = presenceText;
    $[33] = size;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t9) {
    t15 = <div className={styles.text_container}>{t9}{t12}{t13}{t14}</div>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t9;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15 || $[41] !== t4 || $[42] !== t7) {
    t16 = <div className={t4}>{t7}{t15}</div>;
    $[40] = t15;
    $[41] = t4;
    $[42] = t7;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== showContactButton) {
    t17 = showContactButton && <Button classes={[styles.contactButton]} design="outline" onClick={_temp}>Contatta</Button>;
    $[44] = showContactButton;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t16 || $[47] !== t17) {
    t18 = <div className={styles.buttonAndContainer}>{t16}{t17}</div>;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
};
export const PrivateUserProfileBadge = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ErrorBoundary><PrivateUserProfileBadgeComponent {...props} /></ErrorBoundary>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export { PrivateUserBadgeSize };
function _temp() {
  window.dispatchEvent(new CustomEvent("subito:AdView:BtnAuthorReply"));
}